export default "__VITE_ASSET__Dy0r1EkA__"